import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'delete-page-dialog',
    templateUrl: './deletePageDialog.component.html',
    styleUrls: ['./deletePageDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class DeletePageDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    eventForm: FormGroup;


    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<DeletePageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.translationLoader.loadTranslations(polish);
    }
}
